module.exports = __webpack_public_path__ + "static/img/pending-call-bg.f2dc3f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pending-call-bg.png
// module id = /X30
// module chunks = 36